// Scrolled Navigation - Detects header after page loads
window.addEventListener('load', function () {
	const nav = document.querySelector<HTMLElement>('.pageHeader');
	if (!nav) {
		return;
	}
	const yOffset = window.pageYOffset;
	const navHeight = nav.offsetHeight;

	if (yOffset >= navHeight) {
		document.body.classList.add('sticky');
	} else {
		document.body.classList.remove('sticky');
	}

	window.addEventListener('scroll', function () {
		const yOffset = window.pageYOffset;

		if (yOffset >= navHeight) {
			document.body.classList.add('sticky');
		} else {
			document.body.classList.remove('sticky');
		}
	});
});
